package com.zi.support.shared

/** What a support notification is about; each platform maps these to its own icon and colour. */
enum class NotificationKind(val label: String) { TICKET("Tickets"), INCIDENT("Incidents"), CHAT("Chat"), HEATING("Heating"), SYSTEM("System") }

/**
 * Notification inbox rules shared by web, Android and iOS: which kind a notification `type` is, the filter chips,
 * day headers and relative times.
 */
object NotificationKinds {
    const val ALL = "All"
    const val UNREAD = "Unread"

    fun kind(type: String): NotificationKind {
        val t = type.lowercase()
        return when {
            "incident" in t -> NotificationKind.INCIDENT
            "chat" in t -> NotificationKind.CHAT
            "heating" in t -> NotificationKind.HEATING
            "ticket" in t || "subtask" in t || "assignment" in t || "reminder" in t -> NotificationKind.TICKET
            else -> NotificationKind.SYSTEM
        }
    }

    /** "All", "Unread", then one chip per kind. */
    val filters: List<String> = listOf(ALL, UNREAD) + NotificationKind.entries.map { it.label }

    fun matches(filter: String, type: String, read: Boolean): Boolean = when (filter) {
        ALL -> true
        UNREAD -> !read
        else -> kind(type).label == filter
    }

    /** Header for a notification [daysAgo] calendar days old (0 = today, in the viewer's time zone). */
    fun dayGroup(daysAgo: Int): String = when {
        daysAgo <= 0 -> "Today"
        daysAgo == 1 -> "Yesterday"
        else -> "Earlier"
    }

    fun relative(millis: Long, nowMillis: Long): String {
        if (millis <= 0) return ""
        val minutes = (nowMillis - millis).coerceAtLeast(0) / 60_000
        return when {
            minutes < 1 -> "Just now"
            minutes < 60 -> "$minutes min ago"
            minutes < 24 * 60 -> "${minutes / 60} h ago"
            else -> "${minutes / (24 * 60)} d ago"
        }
    }
}
